import { makeRequest } from "./general";

const apiUrl = window.apiUrl;
export default class ClientService {
  constructor() {
    this.baseUrl = apiUrl;
  }

  async evaluateDocument(document) {
    const url = `${this.baseUrl}/api/Client/EvaluateDocument/${document}`;
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    return await makeRequest(url, params);
  }

  async validateClient(formData, transaction) {
    const url = `${this.baseUrl}/api/Client/ValidateClient/${transaction.document}`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Channel": transaction.utmClient || "OnBoardingClient",
        "X-UTM-Campaign": transaction.utmCampaign || "",
        "X-UTM-Content": transaction.utmContent || "",
        Authorization: `Bearer ${transaction.transactionId}/${transaction.document}`,
      },
      body: JSON.stringify(formData),
    };
    return await makeRequest(url, params);
  }

  async getOffer(formData, transaction) {
    const url = `${this.baseUrl}/api/Client/GetOffer/${transaction.idLead}`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${transaction.transactionId}/${transaction.document}`,
        "X-Token": `Bearer ${transaction.transactionId}/${transaction.document}`,
      },
      body: JSON.stringify(formData),
    };
    return await makeRequest(url, params);
  }

  async getCallMe(transaction) {
    const url = `${this.baseUrl}/api/Client/callme/${transaction.idLead}`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${transaction.transactionId}/${transaction.document}`,
        "X-Token": `Bearer ${transaction.transactionId}/${transaction.document}`,
      },
      // body: JSON.stringify(formData),
    };
    return await makeRequest(url, params);
  }

  async confirmOffer(formData, transaction) {
    const url = `${this.baseUrl}/api/Client/ConfirmOffer/${transaction.idLead}`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${transaction.transactionId}/${transaction.document}`,
        "X-Token": `Bearer ${transaction.transactionId}/${transaction.document}`,
      },
      body: JSON.stringify(formData),
    };
    return await makeRequest(url, params);
  }

  async getInfoEstado(transaction) {
    const url = `${this.baseUrl}/api/Client/InfoEstado/${transaction.idLead}/${transaction.codigoEstado}`;
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${transaction.transactionId}/${transaction.document}`,
        "X-Token": `Bearer ${transaction.transactionId}/${transaction.document}`,
      },
    };
    return await makeRequest(url, params);
  }

  async documentsAndBranchAgency(formData, transaction) {
    const url = `${this.baseUrl}/api/Client/DocumentsAndBranchAgency/${transaction.idLead}`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${transaction.transactionId}/${transaction.document}`,
        "X-Token": `Bearer ${transaction.transactionId}/${transaction.document}`,
      },
      body: JSON.stringify(formData),
    };
    return await makeRequest(url, params);
  }

  async confirmPaymentMethod(formData, transaction) {
    const url = `${this.baseUrl}/api/Client/ConfirmPaymentMethod/${transaction.idLead}`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${transaction.transactionId}/${transaction.document}`,
        "X-Token": `Bearer ${transaction.transactionId}/${transaction.document}`,
      },
      body: JSON.stringify(formData),
    };
    return await makeRequest(url, params);
  }

  async mercadoPagoPreference(formData, transaction) {
    const url = `${this.baseUrl}/api/MercadoPago/Preference/${transaction.idLead}`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${transaction.transactionId}/${transaction.document}`,
        "X-Token": `Bearer ${transaction.transactionId}/${transaction.document}`,
      },
      body: JSON.stringify(formData),
    };
    return await makeRequest(url, params);
  }

  async termsAndConditions(formData, transaction) {
    const url = `${this.baseUrl}/api/Client/TermsAndConditions/${transaction.idLead}`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${transaction.transactionId}/${transaction.document}`,
        "X-Token": `Bearer ${transaction.transactionId}/${transaction.document}`,
      },
      body: JSON.stringify(formData),
    };
    return await makeRequest(url, params);
  }

  async redirectToAnexoServicios(transaction) {
    const url = `${this.baseUrl}/api/Client/RedirectToAnexoServicios/${transaction.idLead}`;
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${transaction.transactionId}/${transaction.document}`,
        "X-Token": `Bearer ${transaction.transactionId}/${transaction.document}`,
      },
    };
    return await makeRequest(url, params);
  }

  async additionalCards(formData, transaction) {
    const url = `${this.baseUrl}/api/Client/AdditionalCards/${transaction.idLead}`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${transaction.transactionId}/${transaction.document}`,
        "X-Token": `Bearer ${transaction.transactionId}/${transaction.document}`,
      },
      body: JSON.stringify(formData),
    };
    return await makeRequest(url, params);
  }

  async hiredServices(formData, transaction) {
    const url = `${this.baseUrl}/api/Client/HiredServices/${transaction.idLead}`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${transaction.transactionId}/${transaction.document}`,
        "X-Token": `Bearer ${transaction.transactionId}/${transaction.document}`,
      },
      body: JSON.stringify(formData),
    };
    return await makeRequest(url, params);
  }
}
